<template>
    <div class="DailyResidentialDispensationPlan">
        <div class="row">
            <h3>
                <font-awesome-icon :icon="['fa', 'arrow-left']" @click="ChangeStartDate(-1)" class="pointer" /> <font-awesome-icon :icon="['fa', 'sync-alt']" @click="GetDailyPlan()" class="olive-green-text pointer" />  <font-awesome-icon :icon="['fa', 'arrow-right']" @click="ChangeStartDate(1)" class="pointer" />
                <br />
                <!--<b-button @click="">{{formatDate(StartDate)}}</b-button>-->
                <flat-pickr class="form-control" v-model="TargetDate" :config="DateConfig" @input="GetDailyPlan()"></flat-pickr>
            </h3>
        </div>
        <div>
            <div class="row medication-daily-plan">
                <div class="col">
                    <h4 class="center-text bold"><LiveClock @evenminute="GetDailyPlan(false)"/></h4>
                </div>
            </div>
            <div class="row medication-daily-plan">
                <div class="col PENDING">
                    <p class="center-text bold">PENDING</p>
                </div>
                <div class="col GIVE">
                    <p class="center-text bold">GIVE NOW</p>
                </div>
                <div class="col DISPENSED bold">
                    <p class="center-text">DISPENSED</p>
                </div>
                <div class="col LATE bold">
                    <p class="center-text">LATE</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div style="border-style:solid;margin-top:10px;">
                        <h2 class="bold center-text">Medication Plan: {{formatDate(TargetDate,'dddd MM/DD/YYYY')}}</h2>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="medication-daily-plan plan-set">
            <div class="row plan-block" v-for="timeBlock in DailyPlan" v-bind:class="timeBlock.Status">
                <div class="col">
                    <h2>{{timeBlock.Label}}</h2>
                    <div class="row plan-hour" v-for="timeHour in timeBlock.TimeOfDaySections" v-bind:class="timeHour.Status">
                        <div class="col">
                            <h4>{{formatDate(timeHour.ScheduledTime, 'h A')}}</h4>
                            <div class="row plan-dose" v-for="dose in timeHour.ScheduledDoses" v-bind:class="dose.Status" @click="OpenDose(dose)">
                                <div class="col-11">
                                    <p><span class="bold">{{dose.ClientName}}</span>: {{dose.MedicationDescription}}, {{dose.QuantityDescription}}</p>
                                </div>
                                <div class="col-1">
                                    <p style="text-align: right;">{{dose.Status}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DispensationRecorder ref="ele-dispensationrecorder" @updateddata="GetDailyPlan" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowRight);
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faTrash } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrash);

    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import DispensationRecorder from './DispensationRecorder.vue';
    import LiveClock from '../UI/LiveClock.vue';

    export default {
        name: "DailyResidentialDispensationPlan",
        props: [
            "ResidenceId"
        ],
        data: function () {
            return {
                TargetDate: null,
                DailyPlan: []
            };
        },
        methods: {
            ChangeStartDate(magnitude) {
                this.TargetDate = moment(this.TargetDate, 'YYYY-MM-DD').add(magnitude, 'days').format("YYYY-MM-DD");
                this.GetDailyPlan();
            },
            GetDailyPlan(showLoad = true) {
                this.$MasterAPI.ExecuteRequest("GET", "Medication/DispensationPlan/Daily", { ResidenceID: this.ResidenceId, TargetDate: this.TargetDate }, this.GetDailyPlanSuccess, () => { }, showLoad);
            },
            GetDailyPlanSuccess(response) {
                this.DailyPlan = response.data.data;
            },

            OpenDose(doseInfo) {
                this.$refs["ele-dispensationrecorder"].Open(doseInfo);
            },
            
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DDThh:mm:ss').format(fmt)
            },
            DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
            },
             CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            flatPickr,
            DispensationRecorder,
            LiveClock
        },
        mounted() {
            this.TargetDate = moment().format("YYYY-MM-DD");
            //this.GetDailyPlan();
        },
        computed: {

        }
    }
</script>

<style scoped>

    .center-cells td, .center-cells th {
        text-align: center;
    }

    table td, table th {
        border-style: solid;
    }
</style>